module.exports = __webpack_public_path__ + "static/media/PS.3c893b30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PS.svg
// module id = 2243
// module chunks = 7